import { useRef, useState } from "react";
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfUnity } from 'src/database/index';

import api from 'src/services/api';
import { useAuth } from "src/contexts/auth";
import { AxiosResponse } from "axios";

export const useFormCreateUnitys = () => {
  const { userAgencyId } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [unityResponse, setUnityResponse] = useState<AxiosResponse | null>(null);
  const [unityEditedResponse, setUnityEditedResponse] = useState<AxiosResponse | null>(null);

  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    NOME: Yup.string().required('* Campo obrigatório'),
    EMAIL: Yup.string().email('* Informe um email válido').required('* Campo obrigatório'),
    TELEFONE: Yup.string().required('* Campo obrigatório'),
    TIPOUNIDADE: Yup.number().required('* Campo obrigatório'),
  });

  const saveUnity = async (Unity: ModelOfUnity) => {
    setLoading(true);

    const newUnity: ModelOfUnity = {
      ...Unity,
      ORGAO: userAgencyId
    }

    if (!!unityResponse) {
      api.put(`unitys/${unityResponse.data.ID}`, newUnity)
        .then((response) => {
          formik.resetForm();
          setUnityEditedResponse(response);
          setUnityResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'A unidade foi editada com sucesso!', life: 5000 });
        }).catch((err) => {
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        })
    } else {
      api.post('unitys', newUnity)
        .then((response) => {
          setUnityResponse(response);
          setUnityEditedResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Operação realizada com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        });
    }
  }

  const formik = useFormik<ModelOfUnity>({
    initialValues: {
      ORGAO: '',
      NOME: '',
      EMAIL: '',
      TELEFONE: '',
      TIPOUNIDADE: 0
    },
    onSubmit: async values => await saveUnity(values),
    validationSchema
  });

  return {
    getUnityFormController: {
      formik,
      loading,
      toast,
      unityResponse,
      unityEditedResponse
    },
    handleUnityFormController: {
      setUnityResponse,
      setUnityEditedResponse
    }
  };
};
